import React from 'react';
import PropTypes from 'prop-types';
import DropdownButton from 'react-bootstrap/lib/DropdownButton';
import MenuItem from 'react-bootstrap/lib/MenuItem';
import { defineMessages, injectIntl } from 'react-intl';

import intlShape from '@/shared/utils/intlShape';

const messages = defineMessages({
  RelationGlobalActionsTooltip:
    'Select one or more relations to execute a global action on these relations.',
  GlobalActions: 'Global actions',
  AddOrRemoveTaskSchedule: 'Add or remove task schedule',
});

const GlobalActionsButton = props => {
  const { intl, disabled, onUpdateTaskSchedule } = props;

  return (
    <span
      className="tool-tip"
      data-toggle="tooltip"
      data-placement="top"
      title={disabled ? intl.formatMessage(messages.RelationGlobalActionsTooltip) : ''}
    >
      <DropdownButton
        bsSize="xsmall"
        bsStyle="default"
        className="btn-inverse"
        id="global-actions-button"
        disabled={disabled}
        pullRight
        title={intl.formatMessage(messages.GlobalActions)}
      >
        <MenuItem onSelect={onUpdateTaskSchedule}>
          {intl.formatMessage(messages.AddOrRemoveTaskSchedule)}
        </MenuItem>
      </DropdownButton>
    </span>
  );
};

GlobalActionsButton.propTypes = {
  intl: intlShape.isRequired,
  onUpdateTaskSchedule: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
};
GlobalActionsButton.defaultProps = { disabled: false };
export default injectIntl(GlobalActionsButton);
